import { render } from "./company-parents.vue?vue&type=template&id=c983b026&scoped=true"
import script from "./company-parents.vue?vue&type=script&lang=js"
export * from "./company-parents.vue?vue&type=script&lang=js"

import "./company-parents.vue?vue&type=style&index=0&id=c983b026&lang=less&scoped=true"

import exportComponent from "/Users/jixubin/thinkcloud/thinkcloud-merchant-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c983b026"]])

export default __exports__